// Busca aproximada: cada palavra digitada precisa aparecer em algum dos textos, em
// qualquer ordem e sem diferenciar acentos. "Maria Germano" acha "Maria Ferreira Germano".
// É a mesma regra da busca no servidor (utils/sqlSearch.ts no backend).
const LIGACOES = new Set(['a', 'as', 'da', 'das', 'de', 'do', 'dos', 'e', 'o', 'os'])

export const normalizarBusca = (valor) => String(valor ?? '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()

export const termosDeBusca = (busca) => {
  const termos = normalizarBusca(busca).split(/\s+/).filter(Boolean)
  const uteis = termos.filter((t) => !LIGACOES.has(t))
  return uteis.length ? uteis : termos
}

export const combinaBusca = (textos, busca) => {
  const termos = termosDeBusca(busca)
  if (!termos.length) return true
  const alvo = normalizarBusca((Array.isArray(textos) ? textos : [textos]).filter((t) => t !== null && t !== undefined).join(' '))
  return termos.every((t) => alvo.includes(t))
}

const textoDoNo = (no) => {
  if (no === null || no === undefined || typeof no === 'boolean') return ''
  if (typeof no === 'string' || typeof no === 'number') return String(no)
  if (Array.isArray(no)) return no.map(textoDoNo).join(' ')
  return textoDoNo(no.props?.children)
}

// filterOption dos Select com busca: olha o que a pessoa vê na opção
export const filtrarOpcao = (busca, option) => {
  const visivel = [option?.['data-search'], textoDoNo(option?.label), textoDoNo(option?.children)].filter(Boolean)
  return combinaBusca(visivel.length ? visivel : option?.value, busca)
}
